module.exports = __webpack_public_path__ + "img/auto_confirm.945d6620.svg";